export enum RegistrationStatus {
  Created = 'Created',
  Pending = 'Pending',
  Unlocked = 'Unlocked',
  Locked = 'Locked'
}

export function parseRegistrationStatus(value: any): RegistrationStatus | undefined {
  if (!value) return undefined;
  const v = String(value).toLowerCase();
  switch (v) {
    case 'created': return RegistrationStatus.Created;
    case 'pending': return RegistrationStatus.Pending;
    case 'unlocked': return RegistrationStatus.Unlocked;
    case 'locked': return RegistrationStatus.Locked;
    default: return undefined;
  }
}

